import { Component, computed, inject, input, output } from '@angular/core';
import { UiService } from '../../../services/ui.service';
import { GLOBAL_CONSTANT } from '../../../constants/global.constant';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-wizard-header',
  imports: [NzIconModule],
  templateUrl: './wizard-header.html',
  styleUrl: './wizard-header.scss',
})
export class WizardHeader {
  public ui = inject(UiService);
  isMobile = computed(() => this.ui.IsMobile());
  isTablet = computed(() => this.ui.IsTablet());

  wizard = input(false);
  wizardsteps = input<string[]>([]);
  start = input(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  currentstep = input(GLOBAL_CONSTANT.DEFAULT_INITIALIZER);
  currentstepError = input(false);
  noLabelWizard = input(false);
  overflowEnd = input(true);
  overflowStart = input(false);
  transparent = input(false);
  overlap = input(false);
  title = input(GLOBAL_CONSTANT.EMPTY_STRING);
  noEditBtn = input(true);
  plantHeader = input(true);
  eqHeaderId = input<any>(GLOBAL_CONSTANT.EMPTY_STRING);
  plantHeaderId = input<number | string>(GLOBAL_CONSTANT.EMPTY_STRING);
  sensorHeaderIds = input<string[]>([GLOBAL_CONSTANT.EMPTY_STRING, GLOBAL_CONSTANT.EMPTY_STRING]);
  show4SensorDau = input(false);

  wizardButtonClick = output<number>();
  backButtonClick = output<boolean>();

  onWizardButtonClick(i: number): void {
    this.wizardButtonClick.emit(i);
  }
}
